// 9fbef606107a605d69c0edbcd8029e5d
import ADD_GIFT_CARD_CONSTANTS from '../AddGiftCard.constants';

export const addGiftCardRequest = (payload) => {
  return {
    type: ADD_GIFT_CARD_CONSTANTS.ADD_GIFT_CARD_REQUEST,
    payload,
  };
};

export const addGiftCardFailure = (payload) => {
  return {
    type: ADD_GIFT_CARD_CONSTANTS.ADD_GIFT_CARD_FAILED,
    payload,
  };
};

export const addGiftCardSuccess = (payload) => {
  return {
    type: ADD_GIFT_CARD_CONSTANTS.ADD_GIFT_CARD_SUCCESS,
    payload,
  };
};

export const resetShowNotification = () => {
  return {
    type: ADD_GIFT_CARD_CONSTANTS.RESET_SHOW_NOTIFICATION,
  };
};
